import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { getMaterialInfo } from '../../utils/helpers';

/**
 * Material Card Component
 * 
 * Quick access card for material types
 */
const MaterialCard = ({
  type,
  variant = 'default',
  className = '',
}) => {
  const info = getMaterialInfo(type);
  const path = `/${type}-calculator`;

  if (variant === 'compact') {
    return (
      <Link
        to={path}
        className={`
          flex items-center gap-3 p-4 rounded-xl
          bg-white border border-gray-200
          hover:border-blue-300 hover:shadow-md
          transition-all group
          ${className}
        `}
      >
        <span className="text-3xl">{info.icon}</span>
        <div className="flex-1">
          <div className="font-semibold text-gray-900">{info.name}</div>
          <div className="text-sm text-gray-500">{info.description}</div>
        </div>
        <ArrowRight className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transition-colors" />
      </Link>
    );
  }

  return (
    <Link
      to={path}
      className={`
        block p-6 rounded-2xl
        ${info.color} border border-transparent
        hover:border-blue-300 hover:shadow-lg
        transition-all group
        ${className}
      `}
    >
      <div className="text-4xl mb-3">{info.icon}</div>
      <h3 className="font-bold text-lg text-gray-900 mb-1">{info.name}</h3>
      <p className="text-sm text-gray-600 mb-4">{info.description}</p>
      <div className="flex items-center gap-2 text-blue-600 font-medium text-sm group-hover:gap-3 transition-all">
        Calculate now
        <ArrowRight className="w-4 h-4" />
      </div>
    </Link>
  );
};

export default MaterialCard;
